(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:AddEditDistanceCtrl
     *
     * @description
     *
     */
    angular
        .module('greatCircleDistance')
        .controller('AddEditDistanceCtrl', AddEditDistanceCtrl);

    function AddEditDistanceCtrl(MessageService, CommonMasterData, $uibModalInstance, modalParams, GreatCircleDistanceService) {
        var vm = this;
        vm.model = {
    		request : {
    			origin : modalParams.origin,
                destination :  modalParams.destination,
                distance : 	modalParams.distance,
                gridCircleId : modalParams.gridCircleId
    		},
            airportList : modalParams.airportList,
            modalTitle : modalParams.gridCircleId == undefined ? "Add" : "Edit"
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        vm.onSaveDistance = function () {
        	var isUpdate = !angular.isUndefined(vm.model.request.gridCircleId);
        	if(!isUpdate && vm.model.request.origin.airPortCode == vm.model.request.destination.airPortCode) {
    			MessageService.error('Origin and Destination can not be same');
    			return;
        	}
            if(vm.searchAny.$valid){
            	GreatCircleDistanceService.saveGridCircularDistance(vm.model.request,
                    function(data){
                        if(data.success) {
                            $uibModalInstance.close('SUCCESS');
                            if(isUpdate) {
                            	MessageService.success('Distance Updated Successfully');
                            } else {
                            	MessageService.success('Distance Added Successfully');                            	
                            }
                        }
                    },
                    function(error){
                        MessageService.error(error.msg[0]);
                    }
                );
            }
        }
    }
}());
